import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import styles from './styles.module.scss';
import SVGMouth from '../OrganData/SVGMouth';
import { useSelector } from 'react-redux';
import { arrayOfTimesGeneral } from '../../../../pages/Appointments/timeLines';

const QuickEditModal = ({
  quickEditApt,
  quickEditForm,
  users,
  handleQuickEditChange,
  handleToothClick,
  setQuickEditForm,
  autoResizeTextarea,
  onSaveQuickEdit,
  cancelQuickEdit,
  handleDeleteApt,
  isFromCalendar = false,
  t,
  setQuickEditApt,
}) => {
  const [showConfirm, setShowConfirm] = React.useState(false);
  const [serviceMenuOpen, setServiceMenuOpen] = useState(false);
  const [serviceSearchInput, setServiceSearchInput] = useState('');
  const menuRef = useRef(null);
  const { operations } = useSelector((state) => state.operations);
  console.log('Current category:', quickEditForm.category);
  console.log('Search input:', serviceSearchInput);

  const handleClickOutside = (e) => {
    if (menuRef.current && !menuRef.current.contains(e.target)) {
      setServiceMenuOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const filteredServices = operations?.filter((op) => {
    // If operations is undefined or empty, return false
    if (!op || !op.op_name) return false;

    const searchInputLower = serviceSearchInput.toLowerCase();
    const opNameLower = op.op_name.toLowerCase();
    const opCategory = op.category || 'stomatology';
    
    // If there's a search input, filter by name and category
    if (searchInputLower) {
      return opNameLower.includes(searchInputLower) && 
        (quickEditForm.category === 'stomatology' ? opCategory === 'stomatology' : true);
    }
    
    // If no search input, filter only by category for stomatology
    return quickEditForm.category === 'stomatology' ? opCategory === 'stomatology' : true;
  });

  console.log('Filtered services:', filteredServices);

  const handleServiceSelect = (operation) => {
    const serviceCost = operation.price || 0;
    const patientPay = parseFloat(quickEditForm.patient_pay) || 0;
    const difference = serviceCost - patientPay;

    setQuickEditForm({
      ...quickEditForm,
      service_name: operation.op_name,
      service_cost: serviceCost,
      difference: difference
    });
    setServiceMenuOpen(false);
  };

  // Handle delete action
  const onDeleteClick = () => {
    setShowConfirm(true);
  };

  const confirmDelete = () => {
    if (!quickEditApt) return;
    console.log('Deleting appointment:', quickEditApt);
    console.log('Is from calendar:', isFromCalendar);
    handleDeleteApt(quickEditApt, isFromCalendar);
    setShowConfirm(false);
    setQuickEditApt(null);
  };

  const cancelDelete = () => {
    setShowConfirm(false);
  };

  const saveQuickEdit = () => {
    if (!quickEditApt) return;
    onSaveQuickEdit();
  };

  if (!quickEditApt) return null;
  
  return createPortal(
    <>
      <div className={styles.quickedit_overlay}>
        <div className={styles.quickedit_modal}>
          <div className={styles.quickedit_header}>
            <h3>Ndrysho Terminin</h3>
            <button className={styles.close_btn} onClick={cancelQuickEdit} aria-label="Mbyll">✖</button>
          </div>
          <form className={styles.quickedit_form} autoComplete="off" onSubmit={e => { e.preventDefault(); saveQuickEdit(); }}>
            <div className={styles.quickedit_grid}>
              {/* Service Name */}
              <div className={styles.form_entry} ref={menuRef}>
                <label htmlFor="service_name">Emri i shërbimit</label>
                <div className={`${styles.op_selector_container} ${serviceMenuOpen ? styles.active_menu : ''}`}>
                  <input 
                    type="text" 
                    id="service_name" 
                    name="service_name" 
                    value={quickEditForm.service_name} 
                    className={styles.selector_input}
                    placeholder="Zgjidh shërbimin..."
                    onClick={() => setServiceMenuOpen(!serviceMenuOpen)}
                    readOnly
                    required
                  />
                  <div className={styles.op_menu_container}>
                    <div className={styles.op_menu_search}>
                      <input
                        className={styles.op_menu_search_input}
                        value={serviceSearchInput}
                        placeholder={t('search')}
                        onChange={(e) => setServiceSearchInput(e.target.value)}
                      />
                    </div>
                    <ul className={styles.op_menu_list_container}>
                      {filteredServices?.length ? (
                        filteredServices?.map((op) => (
                          <li
                            key={op.id}
                            className={styles.op_menu_item}
                            onClick={() => handleServiceSelect(op)}
                          >
                            <span className={styles.op_menu_text}>{op.op_name} - {op.price}€</span>
                          </li>
                        ))
                      ) : (
                        <li className={`${styles.op_menu_item} ${styles.disabled_entry}`} disabled>
                          <span className={styles.op_menu_text} style={{ textAlign: 'center', width: '100%' }}>
                            {t('no_services')}
                          </span>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
                <small id="service_name_help" className={styles.helper_text}>Zgjidh shërbimin nga lista.</small>
              </div>
              {/* Doctor Selection */}
              <div className={styles.form_entry}>
                <label htmlFor="doctor_id">Mjeku</label>
                <select
                  id="doctor_id"
                  name="doctor_id"
                  value={quickEditForm.doctor_id}
                  onChange={handleQuickEditChange}
                  className={styles.select_field}
                  aria-describedby="doctor_id_help"
                >
                  <option value="">-- Zgjidh mjekun --</option>
                  {users?.map(user => (
                    <option key={user.id} value={user.id}>
                      {user.displayName} {user.role ? `(${user.role})` : ''}
                    </option>
                  ))}
                </select>
                <small id="doctor_id_help" className={styles.helper_text}>Zgjidh mjekun për këtë takim.</small>
              </div>
              {/* Date and Time Selection */}
              <div className={styles.form_entry}>
                <label htmlFor="date">Data</label>
                <input
                  type="date"
                  id="date"
                  name="date"
                  value={quickEditForm.date}
                  onChange={handleQuickEditChange}
                  className={styles.input_field}
                  required
                  lang="en-GB"
                  onFocus={(e) => {
                    // Set the date format to DD/MM/YYYY when focused
                    if (e.target.value) {
                      const date = new Date(e.target.value);
                      e.target.value = date.toLocaleDateString('en-GB');
                    }
                  }}
                  onBlur={(e) => {
                    // Convert back to YYYY-MM-DD for the date input
                    if (e.target.value) {
                      const [day, month, year] = e.target.value.split('/');
                      if (day && month && year) {
                        e.target.value = `${year}-${month}-${day}`;
                      }
                    }
                  }}
                  aria-describedby="date_help"
                />
                <small id="date_help" className={styles.helper_text}>Zgjidh datën e takimit.</small>
              </div>
              <div className={styles.form_entry}>
                <label htmlFor="time">Ora</label>
                <select
                  id="time"
                  name="time"
                  value={quickEditForm.time}
                  onChange={handleQuickEditChange}
                  className={styles.input_field}
                  required
                  aria-describedby="time_help"
                >
                  {arrayOfTimesGeneral.map((time) => (
                    <option key={time.value} value={time.displayValue}>
                      {time.displayValue}
                    </option>
                  ))}
                </select>
                <small id="time_help" className={styles.helper_text}>Zgjidh orën e takimit.</small>
              </div>
              {/* Hidden Financial Information */}
              <div className={styles.form_entry} style={{ display: 'none' }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px' }}>
                  <div>
                    <label htmlFor="service_cost">Kosto e shërbimit</label>
                    <input 
                      type="number" 
                      id="service_cost" 
                      name="service_cost" 
                      value={quickEditForm.service_cost} 
                      onChange={handleQuickEditChange}
                      className={styles.input_field}
                      placeholder="0"
                      min="0"
                      step="0.01"
                      aria-describedby="service_cost_help"
                    />
                    <small id="service_cost_help" className={styles.helper_text}>Shkruani koston totale të shërbimit.</small>
                  </div>
                  <div>
                    <label htmlFor="patient_pay">Pagesa e pacientit</label>
                    <input 
                      type="number" 
                      id="patient_pay" 
                      name="patient_pay" 
                      value={quickEditForm.patient_pay} 
                      onChange={handleQuickEditChange}
                      className={styles.input_field}
                      placeholder="0"
                      min="0"
                      step="0.01"
                      aria-describedby="patient_pay_help"
                    />
                    <small id="patient_pay_help" className={styles.helper_text}>Shkruani shumën që ka paguar pacienti.</small>
                  </div>
                  <div>
                    <label htmlFor="difference">Diferenca</label>
                    <input 
                      type="number" 
                      id="difference" 
                      name="difference" 
                      value={quickEditForm.difference} 
                      onChange={handleQuickEditChange}
                      className={styles.input_field}
                      placeholder="0"
                      step="0.01"
                      readOnly
                      aria-describedby="difference_help"
                    />
                    <small id="difference_help" className={styles.helper_text}>Diferenca llogaritet automatikisht.</small>
                  </div>
                </div>
              </div>
              
              {/* Hidden inputs to maintain functionality */}
              <input
                type="hidden"
                name="service_cost"
                value={quickEditForm.service_cost}
              />
              <input
                type="hidden"
                name="patient_pay"
                value={quickEditForm.patient_pay}
              />
              <input
                type="hidden"
                name="difference"
                value={quickEditForm.difference}
              />
              
              {/* Teeth Selection - Only show for stomatology category */}
              {quickEditForm.category !== 'pulmonology' && (
                <div className={styles.form_entry} style={{ gridColumn: '1 / -1' }}>
                  <label>Zgjedhja e dhëmbëve</label>
                  <div className={styles.teeth_selection_card}>
                    <div className={styles.teeth_buttons}>
                      <button
                        type="button"
                        className={`${styles.teeth_button} ${quickEditForm.selectedType === 'all' ? styles.active : ''}`}
                        onClick={() => setQuickEditForm({...quickEditForm, selectedType: 'all'})}
                      >
                        <span role="img" aria-label="Dhëmbë">🦷</span> Të gjitha
                      </button>
                      <button
                        type="button"
                        className={`${styles.teeth_button} ${quickEditForm.selectedType === 'adult' ? styles.active : ''}`}
                        onClick={() => setQuickEditForm({...quickEditForm, selectedType: 'adult'})}
                      >
                        <span role="img" aria-label="Rritur">🧑</span> Rritur
                      </button>
                      <button
                        type="button"
                        className={`${styles.teeth_button} ${quickEditForm.selectedType === 'child' ? styles.active : ''}`}
                        onClick={() => setQuickEditForm({...quickEditForm, selectedType: 'child'})}
                      >
                        <span role="img" aria-label="Fëmijë">🧒</span> Fëmijë
                      </button>
                    </div>
                    <div className={styles.teeth_chart}>
                      <SVGMouth 
                        selectedType={quickEditForm.selectedType} 
                        selectedTeeth={quickEditForm.selectedTeeth} 
                        onToothclick={handleToothClick} 
                      />
                    </div>
                  </div>
                  <small className={styles.helper_text}>Zgjidh dhëmbët që përfshihen në procedurë.</small>
                </div>
              )}
              {/* Medical Notes */}
              <div className={styles.form_entry}>
                <label htmlFor="feedback">Komente</label>
                <textarea 
                  id="feedback" 
                  name="feedback" 
                  value={quickEditForm.feedback} 
                  onChange={handleQuickEditChange}
                  placeholder="Shkruani komentet"
                  aria-describedby="feedback_help"
                  rows={2}
                  onInput={autoResizeTextarea}
                />
                <small id="feedback_help" className={styles.helper_text}>Shtoni ndonjë koment ose shënim.</small>
              </div>
              {quickEditForm.category !== 'stomatology' && (
                <div className={styles.form_entry}>
                  <label htmlFor="examination">Egzaminimi</label>
                  <textarea 
                    id="examination" 
                    name="examination" 
                    value={quickEditForm.examination} 
                    onChange={handleQuickEditChange}
                    placeholder="Shkruani rezultatet e ekzaminimit"
                    aria-describedby="examination_help"
                    rows={2}
                    onInput={autoResizeTextarea}
                  />
                  <small id="examination_help" className={styles.helper_text}>Përshkruani gjetjet e ekzaminimit.</small>
                </div>
              )}
              <div className={styles.form_entry}>
                <label htmlFor="therapy">Terapia</label>
                <textarea 
                  id="therapy" 
                  name="therapy" 
                  value={quickEditForm.therapy} 
                  onChange={handleQuickEditChange}
                  placeholder="Shkruani terapinë ose trajtimin"
                  aria-describedby="therapy_help"
                  rows={2}
                  onInput={autoResizeTextarea}
                />
                <small id="therapy_help" className={styles.helper_text}>Përshkruani terapinë ose trajtimin.</small>
              </div>
            </div>
            <div className={styles.quickedit_actions}>
              <button type="submit" className={styles.save_btn}>
                Ruaj Ndryshimet
              </button>
              <button type="button" className={styles.delete_btn} onClick={onDeleteClick}>
                Fshi Terminin
              </button>
            </div>
          </form>
        </div>
      </div>
      
      {/* Delete Confirmation Dialog */}
      {showConfirm && (
        <div className={styles.confirm_overlay} style={{ zIndex: 1001 }}>
          <div className={styles.confirm_dialog}>
            <h4>Konfirmim i Fshirjes</h4>
            <p>Jeni të sigurt që dëshironi të fshini këtë termin?</p>
            <p className={styles.note}>
              {isFromCalendar 
                ? "Termini do të fshihet nga kalendari, por do të mbetet në historinë e pacientit."
                : "Termini do të fshihet plotësisht nga sistemi."}
            </p>
            <div className={styles.confirm_actions}>
              <button className={styles.cancel_btn} onClick={cancelDelete}>Anulo</button>
              <button className={styles.confirm_btn} onClick={confirmDelete}>Fshi</button>
            </div>
          </div>
        </div>
      )}
    </>,
    document.body
  );
};

QuickEditModal.propTypes = {
  quickEditApt: PropTypes.object,
  quickEditForm: PropTypes.object.isRequired,
  users: PropTypes.array,
  handleQuickEditChange: PropTypes.func.isRequired,
  handleToothClick: PropTypes.func.isRequired,
  setQuickEditForm: PropTypes.func.isRequired,
  autoResizeTextarea: PropTypes.func.isRequired,
  onSaveQuickEdit: PropTypes.func.isRequired,
  cancelQuickEdit: PropTypes.func.isRequired,
  handleDeleteApt: PropTypes.func.isRequired,
  isFromCalendar: PropTypes.bool,
  t: PropTypes.func,
  setQuickEditApt: PropTypes.func.isRequired,
};

export default QuickEditModal; 